import { render, staticRenderFns } from "./deleteAccount.vue?vue&type=template&id=127d8b48&scoped=true&"
import script from "./deleteAccount.vue?vue&type=script&lang=js&"
export * from "./deleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./deleteAccount.vue?vue&type=style&index=0&id=127d8b48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d8b48",
  null
  
)

export default component.exports